export function deepCopy(origin) {
    return JSON.parse(JSON.stringify(origin))
}

/**
 * 判断传入的值是否是json
 * @param value
 */
export function judgeJson(value) {
    try {
        JSON.parse(value)
    }catch (e) {
        return false
    }
    return true
}

export function judgeObject(objectTemp) {
    return objectTemp !== null && typeof objectTemp === 'object'
}

export async function mergeMultiObject(...objArr) {
    if (!objArr || objArr.length === 0) {
        return {}
    }

    let source = {}
    for (let i = 0; i < objArr.length; i++) {
        let target = objArr[i]
        mergeTwoObject(source, target)
        if (i === objArr.length - 1) {
            return source
        }
    }
}

const mergeTwoObject = (source, target) => {
    for (const key in target) {
        if (source.hasOwnProperty(key)) {
            continue
        }
        source[key] = target[key]
    }
}